var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
import { useLink } from '../hooks/use-link';
import { GridIconGlyph, ChevronLeftIconGlyph } from '@shapeable/icons';
import { useBackButtonEntity } from '../hooks/use-back-button-entity';
import { useComponentPropsFor } from '../context/component-props-context';
var cls = classNames('grid-back-button');
export var GridBackButtonDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: ", "; \n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: ", "; \n  "])), theme.UNIT(3))
});
var IconStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var GridBackButton = function (props) {
  var _a = useComponentPropsFor('GridBackButton', GridBackButtonDefaultProps, props),
    className = _a.className,
    href = _a.href,
    icon = _a.icon;
  var Link = useLink().Link;
  var entity = useBackButtonEntity();
  var Icon = icon || GridIconGlyph;
  return React.createElement(Link, {
    href: entity.path
  }, React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Icon, {
    size: 16,
    color: "text"
  }, React.createElement(ChevronLeftIconGlyph, null)), React.createElement(Icon, {
    size: 25,
    colors: {
      fill: 'text'
    }
  }, React.createElement(GridIconGlyph, null))));
};
GridBackButton.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
// GridBackButton.defaultProps = GridBackButtonDefaultProps;